import { NgModule } from '@angular/core'
import {
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    NbSearchModule,
    NbLayoutModule,
    NbActionsModule,
    NbButtonModule,
    NbBadgeModule,
    NbToggleModule,
    NbSelectModule,
    NbCheckboxModule,
    NbUserModule,
    NbDatepickerModule,
    NbTooltipModule,
    NbRadioModule,
    NbPopoverModule,
    NbListModule,
    NbSpinnerModule,
} from '@nebular/theme'
import { CommonModule } from '@angular/common'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { PvsTableComponent } from './pvs-table/pvs-table.component'
import { PvsFormDialogComponent } from './pvs-form-dialog/pvs-form-dialog.component'
import { FullSizeAvatarComponent } from './full-size-avatar/full-size-avatar.component'
import { PipesModule } from '../@core/pipes/pipes.module'
import { MatPaginatorModule } from '@angular/material/paginator'
import { SingleEmployeePickerComponent } from './single-employee-picker/single-employee-picker.component'
import { TurnColumnComponent } from './turn-column/turn-column.component'
import { TurnInputDialogComponent } from './turn-input-dialog/turn-input-dialog.component'
import { ChooseAvatarComponent } from './choose-avatar/choose-avatar.component'
import { ImageCropperModule } from 'ngx-image-cropper'
import { PvsAvatarComponent } from './pvs-avatar/pvs-avatar.component'
import { EmployeeSortingComponent } from './employee-sorting/employee-sorting.component'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { ScanBarcodeComponent } from './scan-barcode/scan-barcode.component'
import { GiftCardInfoComponent } from './gift-card-info/gift-card-info.component'
import { TurnInputRedeemComponent } from './turn-input-redeem/turn-input-redeem.component'
import { PvsIconComponent } from './pvs-icon/pvs-icon.component'
import { SimpleSortingComponent } from './simple-sorting/simple-sorting.component'
import { UserSelectionComponent } from './user-selection/user-selection.component'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'
import { GiftCardPrintComponent } from './gift-card-print/gift-card-print.component'
import { QrCodeModule } from 'ng-qrcode'
import { TimePickerComponent } from './time-picker/time-picker.component'
import { PhoneNumberComponent } from './phone-number/phone-number.component'
import { PhoneNumberPadComponent } from './phone-number-pad/phone-number-pad.component'
import { DirectivesModule } from '../@core/directives/directives.module'

@NgModule({
    imports: [
        NbCheckboxModule,
        NbCardModule,
        NbIconModule,
        NbInputModule,
        NbTreeGridModule,
        NbSearchModule,
        NbLayoutModule,
        NbActionsModule,
        NbButtonModule,
        NbBadgeModule,
        NbToggleModule,
        NbSelectModule,
        CommonModule,
        FormsModule,
        FlexLayoutModule,
        NbUserModule,
        NbDatepickerModule,
        NbTooltipModule,
        NbRadioModule,
        PipesModule,
        NbPopoverModule,
        MatPaginatorModule,
        NbInputModule,
        NbListModule,
        NbSpinnerModule,
        ImageCropperModule,
        DragDropModule,
        MatFormFieldModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        ReactiveFormsModule,
        QrCodeModule,
        DirectivesModule,
    ],
    declarations: [
        PvsAvatarComponent,
        PvsTableComponent,
        PvsFormDialogComponent,
        ChooseAvatarComponent,
        FullSizeAvatarComponent,
        SingleEmployeePickerComponent,
        EmployeeSortingComponent,
        TurnColumnComponent,
        TurnInputDialogComponent,
        TurnInputRedeemComponent,
        ScanBarcodeComponent,
        GiftCardInfoComponent,
        GiftCardPrintComponent,
        PvsIconComponent,
        SimpleSortingComponent,
        UserSelectionComponent,
        TimePickerComponent,
        PhoneNumberComponent,
        PhoneNumberPadComponent,
    ],
    exports: [
        PvsAvatarComponent,
        PvsTableComponent,
        PvsFormDialogComponent,
        ChooseAvatarComponent,
        FullSizeAvatarComponent,
        SingleEmployeePickerComponent,
        EmployeeSortingComponent,
        TurnColumnComponent,
        TurnInputDialogComponent,
        TurnInputRedeemComponent,
        ScanBarcodeComponent,
        GiftCardInfoComponent,
        GiftCardPrintComponent,
        PvsIconComponent,
        SimpleSortingComponent,
        UserSelectionComponent,
        TimePickerComponent,
        PhoneNumberComponent,
        PhoneNumberPadComponent,
    ],
})
export class ComponentsModule {}
